// extracted by mini-css-extract-plugin
export default {"container":"eff19454ba8fb920","addPrincipal":"dc25627831ba44bf","personList":"_26c11cd552d80549","personListRow":"_245c0ead9bf7f755"};